/**
 * NAZWA PLIKU ŚCIĄGNIĘTEGO Z MASZYNY — czysta reguła podpowiedzi.
 *
 * ══════════════════════════════════════════════════════════════════════════════════════════════
 *  ⚠️⚠️ ISTNIEJE, BO POD JEDNĄ NAZWĄ LEŻĄ RÓŻNE OBRAZKI. Zgłoszone 07.09.2026: „może być sytuacja,
 *  gdzie dla danego produktu na każdym automacie jest inny obrazek mimo tej samej nazwy". Cała
 *  wartość ściągania w górę polega na tym, że da się wziąć wersję z KAŻDEGO automatu i je
 *  porównać — a to jest niemożliwe, jeśli druga wersja nadpisuje pierwszą.
 *
 *  ⚠️⚠️ ROZSTRZYGNIĘTE 07.09.2026: przy zajętej nazwie podpowiadamy NOWĄ (z węzłem), a nadpisanie
 *  zostaje możliwe, ale świadome. Domyślne nadpisanie zamazywałoby jedyną kopię, jaką portal ma
 *  poza automatami — i to bez pytania, w oknie otwartym po to, żeby coś OBEJRZEĆ.
 *
 *  ⚠️ WOLNA NAZWA ZOSTAJE BEZ ZMIAN. Przyrostek „na wszelki wypadek" psułby najczęstszy przypadek:
 *  portal nie ma pliku wcale (13 takich wierszy na testówce PESA), a wtedy właściwa nazwa to
 *  dokładnie ta, którą wskazuje towar — inaczej trzeba by ją poprawiać ręcznie za każdym razem.
 * ══════════════════════════════════════════════════════════════════════════════════════════════
 */

/** Rozbicie na trzon i rozszerzenie. Brak kropki = całość jest trzonem. */
export function rozbijNazwe(nazwa: string): { trzon: string; rozszerzenie: string } {
  const i = nazwa.lastIndexOf('.');
  return i <= 0 ? { trzon: nazwa, rozszerzenie: '' } : { trzon: nazwa.slice(0, i), rozszerzenie: nazwa.slice(i) };
}

/**
 * ⚠️ WĘZEŁ W NAZWIE MUSI PRZEJŚĆ REGUŁĘ NAZW PLIKÓW: `mjm-ven-recon-1` jest bezpieczne, ale
 * identyfikator z kropką albo spacją rozjechałby rozszerzenie. Zostawiamy litery, cyfry, kreskę
 * i podkreślenie; resztę zamieniamy na kreskę i zwijamy powtórzenia.
 */
export function znacznikWezla(nodeId: string): string {
  return nodeId
    .trim()
    .replace(/[^A-Za-z0-9_-]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
}

/**
 * Podpowiedź nazwy dla pliku ściągniętego z maszyny.
 *
 * Wolna → bez zmian. Zajęta → `trzon-wezel.rozszerzenie`. Ta też zajęta → `-2`, `-3`…
 *
 * ⚠️ LICZNIK NA KOŃCU, NIE PRZED WĘZŁEM: nazwy sortują się w galerii alfabetycznie, więc
 * `P0019916-recon-1` i `P0019916-recon-2` stoją obok siebie i widać, że to warianty jednego pliku.
 */
export function nazwaZWezla(nazwa: string, nodeId: string, zajete: readonly string[]): string {
  const zajeteMale = new Set(zajete.map((n) => n.trim().toLowerCase()));
  const wolna = (n: string) => !zajeteMale.has(n.toLowerCase());
  if (wolna(nazwa)) return nazwa;

  const { trzon, rozszerzenie } = rozbijNazwe(nazwa);
  const znacznik = znacznikWezla(nodeId);
  const zWezlem = znacznik === '' ? nazwa : `${trzon}-${znacznik}${rozszerzenie}`;
  if (wolna(zWezlem)) return zWezlem;

  const { trzon: trzonZ, rozszerzenie: rozZ } = rozbijNazwe(zWezlem);
  for (let i = 2; i < 100; i += 1) {
    const proba = `${trzonZ}-${i}${rozZ}`;
    if (wolna(proba)) return proba;
  }
  /** ⚠️ Sto wariantów jednej nazwy to nie jest stan do obsłużenia — oddajemy ostatnią i niech okno pokaże kolizję. */
  return `${trzonZ}-100${rozZ}`;
}
